import axios from 'axios';
const instance = axios.create({
  baseURL: 'https://myburger-4a767.firebaseio.com',
});
export default instance;
